<onyx-modal
  variant="center"
  heading="{{ employee | onyxName }} - {{ `${I18N}.heading` | translate }}"
  [close$]="close$"
  (closeModal)="dialogRef.close()"
>
  <onyx-avatar
    headingIcon
    [user]="employee"
    variant="user"
    [size]="24"
  ></onyx-avatar>

  <div class="container">
    <form [formGroup]="form" [onyxAutoFocus]="true">
      <onyx-dropdown
        [formControl]="form.controls.vehicles"
        label="labels.vehicles"
        [link]="vehicleLink()"
        [options]="VEHICLES_SOURCE"
        [multiple]="true"
        (selectedOptionValueChange)="vehicle.set($event.value)"
      ></onyx-dropdown>
    </form>
  </div>

  <ng-container bottomRightOptions>
    <onyx-button variant="outlined" (click)="close$.next()">
      {{ 'labels.cancel' | translate }}
    </onyx-button>

    <onyx-button
      [disabled]="form.invalid"
      [spinner]="loading()"
      (click)="!loading() ? submit() : null"
    >
      {{ 'labels.save' | translate }}
    </onyx-button>
  </ng-container>
</onyx-modal>
